import React, { useEffect } from 'react';
import Header from "../../components/header/Header";
import FooterSection from "../../components/footer/FooterSection";
import TermsConditionsSection from "./sections/termsConditionSection/TermsConditionsSection";

const TermsConditions = () => {
	const handleScrollToTop = () => {
		window.scrollTo(0, 0);
	}
	
	useEffect(() => {
		handleScrollToTop();
	}, []);
	
	return (
		<div className="termsConditions">
			<Header mode={"dark"} />
			<TermsConditionsSection />
			<FooterSection />
		</div>
	);
};

export default TermsConditions;